import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import RoleService from "../../services/RoleService";

import {
  listSuccess,
  listFail,
  createSuccess,
  createFail,
  detailsSuccess,
  detailsFail,
  updateDetailSuccess,
  updateDetailFail,
  userListSuccess,
  userListFail,
  exportSuccess,
  exportFail,
  dropdownSuccess,   
  dropdownFail,
  getRolesSuccess,
  getRolesFail
} from "../slices/rolesSlice";
import { rolesFail, rolesSuccess } from "../slices/metaSlice";

function* list(data) {
  try {
    const ajax = yield call(RoleService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(RoleService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(RoleService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* update(data) {
  try {
    const ajax = yield call(RoleService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* dropdown(data) {
  try {
    const ajax = yield call(RoleService.dropDown, data.payload);
    if (ajax.status === 200) {
      yield put(rolesSuccess(ajax.data));
    } else {
      yield put(
        rolesFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      rolesFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* users(data) {
  try {
    const ajax = yield call(RoleService.users, data.payload);
    if (ajax.status === 200) {
      yield put(userListSuccess(ajax.data));
    } else {
      yield put(
        userListFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      userListFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* exportUsers(data) {
  try {
    const { fileType = "excel" } = data.payload;

    let extension = "xlsx";
    if (fileType === "csv") {
      extension = "csv";
    } else if (fileType === "pdf") {
      extension = "pdf";
    }

    const ajax = yield call(RoleService.export, data.payload);
    if (ajax.status === 200) {
      const url = window.URL.createObjectURL(new Blob([ajax.data]), {
        type: ajax.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `role_users.${extension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      yield put(exportSuccess());
    } else {
      yield put(
        exportFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      exportFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* rolesDropDown(action) {
  try {
    const ajax = yield call(RoleService.dropDown, action.payload);
    if (ajax.status === 200) {
      yield put(dropdownSuccess(ajax.data));
    } else {
      yield put(
        dropdownFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      dropdownFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      yield put({ type: "cancel" });
    }
  }
}

function* getRoles(action) {
  try {
    const ajax = yield call(RoleService.getRoles, action.payload);
    if (ajax.status === 200) {
      yield put(getRolesSuccess(ajax.data));
    } else {
      yield put(
        getRolesFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      getRolesFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      yield put({ type: "cancel" });
    }
  }
}
export default function* roleSaga() {
  yield all([
    takeLatest("roles/listRequest", list),
    takeLatest("roles/createRequest", create),
    takeLatest("roles/detailsRequest", details),
    takeLatest("roles/updateDetailRequest", update),
    takeLatest("meta/rolesRequest", dropdown),
    takeLatest("roles/exportRequest", exportUsers),
    takeLatest("roles/userListRequest", users),
    takeLatest("roles/dropdownRequest", rolesDropDown),
    takeLatest("roles/getRolesRequest", getRoles),
  ]);
}
